import jQuery from 'jquery';
import {ZIDX} from "./standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();

export class ZIDXMobileMenu{
    win = $( window );
    mobileHeader:JQuery<HTMLElement>;
    mobileHeaderMobileMenu:JQuery<HTMLElement>;
    mobileHeaderMobileMenuIcon:JQuery<HTMLElement>;
    mobileHeaderMobileMenuOverlay:JQuery<HTMLElement>;
    mobileHeaderMobileMenuClosedLinks:JQuery<HTMLElement>;
    scrollbarWidth=0;
    hasScrollbar=false;
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
        this.mobileHeader=$( '.zidxMobileHeader', this.zidx.peakidxShadowRoot);
        this.mobileHeaderMobileMenu=$( '.zidxMobileMenu', this.zidx.peakidxShadowRoot);
        this.mobileHeaderMobileMenuIcon=$( '.zidxMobileMenuIcon', this.zidx.peakidxShadowRoot);
        this.mobileHeaderMobileMenuOverlay=$( '.zidxMobileHeaderOverlay', this.zidx.peakidxShadowRoot);
        this.mobileHeaderMobileMenuClosedLinks=$( '.zidxMobileMenu li.zidxClosed > a', this.zidx.peakidxShadowRoot);
        this.scrollbarWidth=this.zidx.getScrollBarWidth();
        this.init();
    }

    init() {
        let self=this;

        this.mobileHeaderMobileMenuClosedLinks.on("click",function(e){
            e.preventDefault();
            $(this).parent().toggleClass("zidxClosed");
        });


        if(this.mobileHeader.hasClass("zidxMobileAllowFixed")){
            this.win.on( 'scroll', function() {
                var scrollTop = (typeof window.pageYOffset !== "undefined" ) ? window.pageYOffset : ( document.documentElement || document.body.parentNode || document.body ).scrollTop;
                if ( scrollTop > 0 ) {
                    self.mobileHeader.addClass( 'zidxMobileHeaderFixed' );
                } else {
                    self.mobileHeader.removeClass( 'zidxMobileHeaderFixed' );
                }
            } );
        }
        this.win.trigger("scroll");
        $(window).on("clientresize resize", function(ev){
            self.resizeMobileHeader();
        });
        self.resizeMobileHeader();

        this.mobileHeaderMobileMenuIcon.on( 'click', function() {
            self.toggleMenu();
        } );

        this.mobileHeaderMobileMenuOverlay.on( 'click', function() {
            self.toggleMenu();
        } );

    }
    toggleMenu(){
        var w=$(window).width();
        var h=$(window).width();
        var open=false;
        if(this.mobileHeaderMobileMenuIcon.hasClass( 'zidxOpen' )){
            $("body").css("overflow", "auto");
            this.mobileHeaderMobileMenuOverlay.removeClass("zidxOpen");
        }else{
            // $("body").css("overflow", "hidden");
            open=true;
            this.mobileHeaderMobileMenuOverlay.addClass("zidxOpen");
        }
        var nw=$(window).width();
        if(w!=nw){
            this.hasScrollbar=true;
        }else{
            this.hasScrollbar=false;
        }
        this.mobileHeaderMobileMenuIcon.toggleClass( 'zidxOpen' );
        this.mobileHeaderMobileMenu.toggleClass( 'zidxOpen' );
        this.resizeMobileHeader();
    }

    resizeMobileHeader(){
        var marginType="margin-right";
        var left=false;
        if($(".zidxMobileHeader", this.zidx.peakidxShadowRoot).hasClass("zidxMobileHeaderLeft")){
            left=true;
            //	marginType="margin-left";
        }
        var w=$(window).width()!;
        var h=$(window).height()!;
        var open=false;
        if(this.mobileHeaderMobileMenuIcon.hasClass( 'zidxOpen' )){
            open=true;
            this.mobileHeaderMobileMenuOverlay.css({
                "width":Math.round(w*2)+"px",
                "height":Math.round(h*2)+"px"
            });
        }
        var nw=$(window).width();
        // keep screen from shifting
        if(this.hasScrollbar){
            if(open){
                $("body").css(marginType, this.scrollbarWidth+"px");
                if(this.mobileHeader.hasClass("zidxMobileAllowFixed") && this.zidx.scrollPosition.top != 0){
                    $(".zidxMobileMenuIcon", this.zidx.peakidxShadowRoot).css("right", (20+this.scrollbarWidth)+"px");
                    if(left){
                        $(".zidxMobileHeader", this.zidx.peakidxShadowRoot).css("width", (w-this.scrollbarWidth)+"px");
                    }else{
                        $(".zidxMobileHeader", this.zidx.peakidxShadowRoot).css("width", (w)+"px");
                    }
                }else{
                }
            }else{
                $(".zidxMobileHeader", this.zidx.peakidxShadowRoot).css("width", "100%");
                $("body").css(marginType, "0px");
                if(this.mobileHeader.hasClass("zidxMobileAllowFixed") && this.zidx.scrollPosition.top != 0){
                    $(".zidxMobileMenuIcon", this.zidx.peakidxShadowRoot).css("right", "20px");
                }
            }
        }else{
            $(".zidxMobileHeader", this.zidx.peakidxShadowRoot).css("width", "100%");
            $("body").css(marginType, "0px");
            $(".zidxMobileMenuIcon", this.zidx.peakidxShadowRoot).css("right", "20px");
        }
    }
}